//
// forms/progressive-profiling.js -- progressive profiling
//
// - Called on load: for each PP-enabled field, if data exists for that field,
//   sets the value and hides it
//

import {data_store} from './data-store';
import {hide_field} from './helpers';
import * as value_extractor  from './value-extractor';


export default function run_progressive_profiling(el_form) {
  if (!el_form.hasAttribute('data-progressive')) {
    return;
  }

  const store = data_store();
  if (store === null) {
    console.log('run_progressive_profiling(): not running - data store could not be initialised');
    return;
  }

  const max_shown_pp_elements = parseInt(el_form.getAttribute('data-progressive-max-fields') || 1);

  const pp_items = Array.from(el_form.querySelectorAll('.c-form-set[data-progressive]'))
    .reduce(
      function(accum, el_div) {
        const value = store.get(el_div.getAttribute('data-name'));

        function is_false(value) {
          return value === null || value === "" || value === "NULL";
        }

        // Checkboxes are never hidden when they are false or not set in the PP data
        if (el_div.getAttribute('data-type') === 'checkbox' && is_false(value)) {
          return accum;
        }

        if (is_false(value)) {
          accum.without_values.push(el_div);
        }
        else {
          accum.with_values.push({ div: el_div, stored_value: value });
        }

        return accum;
      },
      { with_values: [ ], without_values: [ ] }
    );

  // - If there are any PP fields with values, they should be set & hidden.
  pp_items.with_values.forEach(function(item) {
    value_extractor.set_value_div(item.div, item.stored_value);
    hide_field(item.div);
  });

  // - If there are any without values, the first N of these should be shown
  console.log(`
    showing
    ${pp_items.without_values.length - pp_items.without_values.slice(max_shown_pp_elements).length}
    of ${pp_items.without_values.length} un-filled-out pp items
  `);
  pp_items.without_values.slice(max_shown_pp_elements).forEach(hide_field);
}

